import { PlatformBillingCycle } from "@pilatestime/shared-types";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchPublicPlatformPlansQueryOptions } from "@/api/platformBilling";
import PricingBenefitsSection from "./-components/pricing/PricingBenefitsSection";
import PricingCTASection from "./-components/pricing/PricingCTASection";
import PricingHeroSection from "./-components/pricing/PricingHeroSection";
import PricingPlansSection from "./-components/pricing/PricingPlansSection";

export const Route = createFileRoute("/_public/pricing")({
	component: PricingPage,
});

function PricingPage() {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [billingCycle, setBillingCycle] = useState<PlatformBillingCycle>(
		PlatformBillingCycle.MONTHLY,
	);

	const { data: plansData } = useSuspenseQuery(
		fetchPublicPlatformPlansQueryOptions(),
	);

	const handleSelectPlan = () => {
		navigate({ to: "/app" });
	};

	return (
		<div>
			<title>{t("pricing.title")}</title>
			<PricingHeroSection />
			<PricingPlansSection
				plans={plansData.plans}
				billingCycle={billingCycle}
				onBillingCycleChange={setBillingCycle}
				onSelectPlan={handleSelectPlan}
			/>
			<PricingBenefitsSection />
			<PricingCTASection />
		</div>
	);
}
